import { InstantSearch } from 'react-instantsearch';
import { HOME_SEARCH_INDEX_ID } from '@/lib/services/typesense/constants';
import { VirtualSearchBox } from '../VirtualWidgets/VirtualSearchBox';
import { getDynamicProductSearchClient } from '../client/dynamic-product-search';
import { useEffect, useState } from 'react';

const DynamicSearchProvider = ({
  children,
  filters,
  ordering,
  items_per_page,
}: {
  children: React.ReactNode;
  filters?: string;
  ordering?: string;
  items_per_page?: number;
}) => {
  const [productSearchClient, setProductSearchClient] = useState();

  useEffect(() => {
    setProductSearchClient(
      getDynamicProductSearchClient({ filters, ordering, items_per_page }),
    );
  }, []);

  if (!productSearchClient) return null;

  return (
    <InstantSearch
      indexName={HOME_SEARCH_INDEX_ID}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      searchClient={productSearchClient}
    >
      <VirtualSearchBox />
      {children}
    </InstantSearch>
  );
};

export default DynamicSearchProvider;
